import Vue from 'vue'
import vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import state from './state'
Vue.use(vuex)

const getters = {
  nodeTreeArray_get: state => state.nodeTreeArray
}

export default new vuex.Store({
  actions,
  mutations,
  state
})



// WEBPACK FOOTER //
// ./src/vuex/store.js